<template>
  <!-- 审核处理件数统计 -->
  <div class="container-block">
    <!-- 日期筛选、下载报表 -->
    <div class="container-operation">
      <div class="flex">
        <p class="title">查询日期：</p>
        <el-date-picker
          v-model="searchDate"
          type="date"
          placeholder="报表日期"
          value-format="yyyy-MM-dd"
          class="pick-date-block"
        />
      </div>
      <el-button
        type="primary"
        icon="el-icon-search"
        class="btn-list-block"
        @click="onSreachData"
      >
        查询
      </el-button>
      <el-button
        v-if="checkPermission('数据看板:业管看板下载', permList)"
        type="primary"
        icon="iconfont icon-daochu"
        class="btn-list-block"
        @click="onDownloadData"
      >
        下载报表
      </el-button>
    </div>

    <div class="container-content">
      <!-- 业管数据看板-表格 -->
      <el-table
        ref="ygDataTable"
        class="content-tableBlock"
        border
        tooltip-effect="dark"
        :data="tableData"
        :span-method="calculateSpanMerge"
      >
        <el-table-column
          prop="storeHouseName"
          label="数据内容"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="userName"
          label="姓名"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="stockCountNewOld"
          :label="'库存件数\n（新件/补件）'"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="warnCountNewOld"
          :label="'预警件数\n（新件/补件）'"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="overtimeCountNewOld"
          :label="'超时件数\n（新件/补件）'"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="overtimeRate"
          label="超时率"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last7FlowIn"
          label="近7天流进个人库案件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last7Pass"
          label="近7天通过件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last7Refuse"
          label="近7天拒付件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last7RefuseRate"
          align="center"
          label="近7天拒付率"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31FlowIn"
          label="近31天流进个人库案件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31Pass"
          label="近31天通过件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31Refuse"
          label="近31天拒付件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31RefuseRate"
          align="center"
          label="近31天拒付率"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31LowDegreePass"
          label="近31天低度通过案件数"
          align="center"
          show-overflow-tooltip
          width="120"
        />
        <el-table-column
          prop="last31LowDegreePassRate"
          align="center"
          label="近31天低度通过率"
          show-overflow-tooltip
          width="120"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {

  data() {
    return {
      searchDate: '', // 查询日期
      tableData: [], // 数据看板表格数据
      tableSpanArr: [] // 记录每一行的合并数
    }
  },

  computed: {
    ...mapState({
      permList: (state) => state.permission.permList
    })
  },

  created() {
    this.$emit('setCurrentMenu', '审核处理件数统计')
  },

  methods: {
    /**
     * 表格-合并行或列的计算方法
     */
    calculateSpanMerge({ row, column, rowIndex, columnIndex }) {
      const { tableSpanArr } = this
      if (columnIndex == 0) {
        // 判断是否是第一行
        return {
          rowspan: tableSpanArr[rowIndex],
          colspan: tableSpanArr[rowIndex] > 0 ? 1 : 0 // 1为不合并 0为合并至最后一列
        }
      }
    },

    /**
     * 搜索数据
     */
    onSreachData() {
      const { searchDate } = this

      if (searchDate == '') {
        this.$message.error('请选择您要查询的日期！')
      } else {
        if (this.checkPermission('数据看板:业管看板', this.permList)) {
          this.fetchAllDataChartData(searchDate)
        } else {
          this.$message.error('没有权限，请联系管理员授权')
        }
      }
    },

    /**
     * 获取业管数据看板-所有经办人数据
     * @param {string}  date    查询日期
     */
    fetchAllDataChartData(date) {
      const _this = this
      const tableSpanArr = []

      _this.axios.get(_this.homePath() + `/data-chart/query/all/${date}`).then((res) => {
        if (res.data.status == '000000') {
          const result = res && res.data && res.data.data
          const tableData = []

          result &&
            result.excel &&
            result.excel.forEach((item) => {
              item.detail &&
                item.detail.forEach((zItem, zIndex) => {
                  // 记录表格数据的合并数
                  if (zIndex === 0) {
                    tableSpanArr.push(item.detail.length)
                  } else {
                    tableSpanArr.push(0)
                  }

                  // 重新组合数组
                  tableData.push({
                    storeHouseName: item.storeHouseName, // 数据内容
                    userName: zItem.userName, // 姓名
                    stockCountNewOld: zItem.stockCountNewOld || '0/0', // 库存件数（新件/补件）
                    warnCountNewOld: zItem.warnCountNewOld || '0/0', // 预警件数（新件/补件）
                    overtimeCountNewOld: zItem.overtimeCountNewOld || '0/0', // 超时件数（新件/补件）
                    overtimeRate: zItem.overtimeRate || '-', // 超时率
                    last7FlowIn: zItem.last7FlowIn || '0', // 近7天流进个人库案件数
                    last7Pass: zItem.last7Pass || '0', // 近7天通过件数
                    last7Refuse: zItem.last7Refuse || '0', // 近7天拒付件数
                    last7RefuseRate: zItem.last7RefuseRate || '-', // 近7天拒付率
                    last31FlowIn: zItem.last31FlowIn || '0', // 近31天流进个人库案件数
                    last31Pass: zItem.last31Pass || '0', // 近31天通过件数
                    last31Refuse: zItem.last31Refuse || '0', // 近31天拒付件数
                    last31RefuseRate: zItem.last31RefuseRate || '-', // 近31天拒付率
                    last31LowDegreePass: zItem.last31LowDegreePass || '0', // 近31天低度通过案件数
                    last31LowDegreePassRate: zItem.last31LowDegreePassRate || '-' // 近31天拒付率
                  })
                })
            })
          _this.tableData = tableData
          _this.tableSpanArr = tableSpanArr
        } else {
          _this.$alert(res.data.message, '提示')
        }
      })
    },

    /**
     * 业管数据看板-导出
     */
    onDownloadData() {
      const { searchDate } = this

      if (searchDate == '') {
        this.$message.error('请选择您要导出的日期！')
      } else {
        // 跳转文件下载地址
        const url = `${this.homePath()}report/data-chart?reportDate=${searchDate}`
        window.location.href = url
      }
    }
  }
}
</script>

<style scoped lang="scss">
.flex {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}

.container-block {
  width: 100%;
}
.container-operation {
  width: 100%;
  display: flex;
  align-items: center;
  margin-bottom: 30px;

  .title {
    font-size: 14px;
    font-weight: 700;
    margin-bottom: 0;
  }

  .pick-date-block {
    margin-right: 15px;
  }

  .btn-list-block {
    width: 120px;
    margin-right: 15px;
  }
}

.container-content {
  width: 100%;
  margin-bottom: 15px;

  .content-table {
    width: 100%;
  }
}
</style>
